import React from "react";
import Navbar from "../../../../../../components/Navbar";
import Footer from "../../../../../../components/Footer";
import { FaCheckCircle } from "react-icons/fa";
import Scanner from "../../../../../../helper/images/Scanner.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "../../../../../../hooks/useTranslation";

const Tableconfirmation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { reservation } = location.state || {};
  const navigate = useNavigate();

  return (
    <>
      {/* <Navbar /> */}
      <div className="py-[40px]">
        <div className="container">
          <div className="w-full max-w-[737px] mx-auto bg-[#FFF8EC] rounded-[5px] py-[45px] px-[36px] text-center">
            <FaCheckCircle size={32} color="#027D07" className="mx-auto" />
            <h2 className="lg:text-[30px] text-[20px] text-center font-semibold mb-[10px] lg:leading-[40px] text-black mt-[25px] ">
              {reservation?.tableNo
                ? t("tableconfirmation").tableConfirmed.replace(
                    "{tableNo}",
                    reservation.tableNo
                  )
                : t("tableconfirmation").bookingConfirmed}
            </h2>
            {/* <p className="max-w-[470px] mx-auto mb-[30px]">
              {t("tableconfirmation").checkMenuInstruction}
            </p> */}
            <p className="text-center w-full max-w-[380px] text-lg leading-[30px] mx-auto mt-[9px] md:mb-[30px] mb-4">
                {t("tableconfirmation").checkMenuInstruction?.replace(
                  "{{tableCode}}",
                  reservation?.tableCode ?? ""
                )}
              </p>
            {reservation?.qrCode && (
              <img
                src={reservation.qrCode}
                alt="Reservation QR Code"
                className="w-full max-w-[158px] mx-auto"
              />
            )}
            <button
              onClick={() =>
                navigate("/tablecode", {
                  state: { reservation },
                })
              }
              className="w-full max-w-[163px]  rounded-[2px] bg-[#4CAF50] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 green-shadow hover:bg-[#209b25] mt-[30px] inline-block mx-auto"
            >
              {t("tableconfirmation").useCode}
            </button>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default Tableconfirmation;
